import { Delete, Image } from '@mui/icons-material';
import { getDownloadURL, ref, uploadBytes } from 'firebase/storage';
import { fromBlob } from 'image-resize-compress';
import { ChangeEvent, useState } from 'react';
import uniqid from 'uniqid';
import PrimaryButton from '../../components/PrimaryButton';
import { t } from '../../constants/translations';
import { useLocale } from '../../contexts/locale.context';
import { storage } from '../../firebase';

type Props = {
  bgUrl: string;
  setBgUrl: (bgUrl: string) => void;
};

const UploadBG = ({ bgUrl, setBgUrl }: Props) => {
  const { lang } = useLocale();
  const [loading, setLoading] = useState(false);

  const handleFormUploadImg = async (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setLoading(true);
      const file = e.target.files[0];
      const compressedFile = await fromBlob(file, 80, 1000, 'auto', 'webp');
      const id = uniqid();
      const fileRef = ref(storage, `planBg/${id}`);
      await uploadBytes(fileRef, compressedFile);
      const url = await getDownloadURL(fileRef);
      setBgUrl(url);
      setLoading(false);
    }
  };

  const handleRemoveImg = async () => {
    setBgUrl('');
  };

  if (!bgUrl) {
    return (
      <PrimaryButton aria-label="upload" component="label" disabled={loading} startIcon={<Image />}>
        {t.upload_background[lang]}
        <input hidden accept="image/*" multiple type="file" onChange={handleFormUploadImg} />
      </PrimaryButton>
    );
  }

  return (
    <PrimaryButton color="error" onClick={handleRemoveImg} startIcon={<Delete />}>
      {t.remove_background[lang]}
    </PrimaryButton>
  );
};

export default UploadBG;
